import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const GroupLabel = styled.div`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-weight: 700;
  font-size: 16px;
`;
